"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotsIcon = void 0;
const react_1 = __importDefault(require("react"));
const DotsIcon = ({ className }) => (react_1.default.createElement("svg", { className: className, viewBox: "0 0 18 5", width: "17px", height: "5px" },
    react_1.default.createElement("g", { stroke: "currentColor", strokeWidth: "1", fill: "none" },
        react_1.default.createElement("rect", { x: "1", y: "1", width: "4", height: "4" }),
        react_1.default.createElement("rect", { x: "7", y: "1", width: "4", height: "4" }),
        react_1.default.createElement("rect", { x: "13", y: "1", width: "4", height: "4" }))));
exports.DotsIcon = DotsIcon;
//# sourceMappingURL=DotsIcon.js.map